import React from 'react';

import Dashboard from './components/Dashboard';
import Contact from './components/Contact';
import Projects from './components/Projects';
import AboutUs from './components/AboutUs';
import Services from './components/Services';
import ProjectPage from './components/ProjectPage';


export const routes = [
  {
    path: '/',
    element: <Dashboard />,
  },
  {
    path: '/contact',
    element: <Contact />,
  },
  {
    path: '/projects',
    element: <Projects />,
  },
  {
    path: '/about',
    element: <AboutUs />,
  },
  {
    path: '/services',
    element: <Services />,
  },

  {
    path: '/project/:projectId',
    element: <ProjectPage />,
  },
  


];